<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationCourse") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramCode"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="handleSearchProgram()"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtProgramName"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearSelectProgram()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationYear") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control" v-model="selectedYear">
                        <option
                          v-for="(opt, idx) in selectedYearOpts"
                          v-bind:key="idx"
                          v-bind:value="opt.value"
                        >
                          {{ opt.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentChanged"
                      :facultyid="selFaculty"
                      :selectedVal="selDepartment"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentCodeFrom"
                              @keypress="handleSearchStudentFromKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="openDialogSearch('from')"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameFrom"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentFrom()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentCodeTo"
                              @keypress="handleSearchStudentToKey($event)"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="button"
                              @click="openDialogSearch('to')"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameTo"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentTo()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.studentStatus") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <StudentStatus
                      :onChanged="onSelStudentStatusFromChanged"
                      :selectedVal="selStudentStatusFrom"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.studentStatus") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <StudentStatus
                      :onChanged="onSelStudentStatusToChanged"
                      :selectedVal="selStudentStatusTo"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.informStatus") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-group" style="margin-bottom: 0;">
                      <div class="form-inline">
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdInformStatus1"
                            name="rdInformStatus"
                            class="custom-control-input"
                            v-model="infoFormStatus"
                            v-bind:value="2"
                            checked
                          />
                          <label
                            class="custom-control-label"
                            for="rdInformStatus1"
                            >{{ $t("messages.general.selectAll") }}</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdInformStatus2"
                            name="rdInformStatus"
                            class="custom-control-input"
                            v-model="infoFormStatus"
                            v-bind:value="0"
                            checked
                          />
                          <label
                            class="custom-control-label"
                            for="rdInformStatus2"
                            >{{ $t("messages.general.inform") }}</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdInformStatus3"
                            name="rdInformStatus"
                            class="custom-control-input"
                            v-model="infoFormStatus"
                            v-bind:value="1"
                          />
                          <label
                            class="custom-control-label"
                            for="rdInformStatus3"
                            >{{ $t("messages.general.notInform") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.enrollStatus") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-group" style="margin-bottom: 0;">
                      <div class="form-inline">
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdEnrollStatus1"
                            name="rdEnrollStatus"
                            class="custom-control-input"
                            v-model="regStatus"
                            v-bind:value="0"
                          />
                          <label
                            class="custom-control-label"
                            for="rdEnrollStatus1"
                            >{{ $t("messages.general.selectAll") }}</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline"
                        >
                          <input
                            type="radio"
                            id="rdEnrollStatus2"
                            name="rdEnrollStatus"
                            class="custom-control-input"
                            v-model="regStatus"
                            v-bind:value="1"
                            checked
                          />
                          <label
                            class="custom-control-label"
                            for="rdEnrollStatus2"
                            >{{ $t("messages.general.cantSelfRequest") }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="handleSearchStudent()"
                    type="button"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="clearAll()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      ><strong>{{
                        $t("messages.checkStudentInfo.remark")
                      }}</strong></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <span class="text-danger"
                      >{{ $t("messages.checkStudentInfo.remark2") }}
                    </span>
                    <br />
                    <span>{{ $t("messages.checkStudentInfo.remark3") }} </span>
                    <br /><br />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="handleSelect(data.item, data.index)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>

              <template v-slot:cell(STUDENTID)="data">
                <a
                  v-if="data.item.CHECK_CREDIT == 0"
                  class="text-danger"
                  @click="handleSelect(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.STUDENTID }}
                </a>
                <a
                  v-else
                  @click="handleSelect(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.STUDENTID }}
                </a>
              </template>

              <template v-slot:cell(CHECKPREREG)="data">
                <div v-if="data.item.CHECKPREREG == 0">
                  {{ $t("messages.general.notInform") }}
                </div>
                <div
                  v-else
                  @click="handleSelect(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ $t("messages.general.inform") }}
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>

          <v-dialog
            v-model="dialogSearchProgram"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.programNameList")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearchProgram = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{
                            $t("messages.general.programcode")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgProgramCode"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{
                            $t("messages.general.programName")
                          }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgProgramName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onSelFacultyProgramChanged"
                            :selectedVal="selFacultyProgram"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onSelDepartmentProgramChanged"
                            :facultyid="selFacultyProgram"
                            :selectedVal="selDepartmentProgram"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.educationLvl") }}
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onSelLvlProgramChanged"
                            :selectedVal="selLvlProgram"
                            :disabled="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.yearRef") }} </label>
                        </div>
                        <div class="col no-margin-padding">
                          <AcademicYear
                            :onChanged="onSelYearProgramChanged"
                            :selectedVal="selYearProgram"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          class="btn btn-primary btn-lg"
                          type="button"
                          @click="handleProgramSearch()"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-light btn-lg"
                          type="button"
                          @click="cleartSearchProgram()"
                        >
                          {{ $t("messages.general.clearScreen") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableProgram.sortBy"
                    :sort-desc.sync="bTableProgram.sortDesc"
                    :items="bTableProgram.items"
                    :fields="bTableProgram.fields"
                    :per-page="perPage"
                    :current-page="currentPageProgram"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableProgram.items.length"
                        v-model="currentPageProgram"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTableProgram.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPageProgram > 1
                              ? (currentPageProgram - 1) * perPage + 1
                              : currentPageProgram
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPageProgram * perPage >
                              bTableProgram.items.length
                              ? bTableProgram.items.length
                              : currentPageProgram * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableProgram.items.length).toLocaleString()
                        }}
                      </div>
                      <div
                        v-if="bTableProgram.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{
                          Number(bTableProgram.items.length).toLocaleString()
                        }}
                      </div>
                    </template>

                    <template v-slot:cell(PROGRAMCODE)="data">
                      <a
                        @click="handleSelectProgram(data.item, data.index)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.PROGRAMCODE }}
                      </a>
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPage"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableProgram.items.length"
                          v-model="currentPageProgram"
                          :per-page="perPage"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableProgram.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageProgram > 1
                                ? (currentPageProgram - 1) * perPage + 1
                                : currentPageProgram
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageProgram * perPage >
                                bTableProgram.items.length
                                ? bTableProgram.items.length
                                : currentPageProgram * perPage
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableProgram.items.length).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableProgram.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableProgram.items.length).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogSearch"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>search</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.studentListName")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogSearch = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <form>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.identity") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgSearchStudentId"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.fullname") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <div>
                            <input
                              v-model="dlgSearchStudentName"
                              type="text"
                              class="form-control col mr-2"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.faculty") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Faculty
                            :onChanged="onSelFacultySearchChanged"
                            :selectedVal="selFacultySearch"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label>{{ $t("messages.general.department") }}</label>
                        </div>
                        <div class="col no-margin-padding">
                          <Department
                            :onChanged="onSelDepartmentSearchChanged"
                            :facultyid="selFacultySearch"
                            :selectedVal="selDepartmentSearch"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.educationLvl") }}
                          </label>
                        </div>
                        <div class="col no-margin-padding">
                          <Level
                            :onChanged="onSelLvlSearchChanged"
                            :selectedVal="selLvlSearch"
                            :disabled="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.from") }}
                            {{ $t("messages.general.studentStatus") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <StudentStatus
                            :onChanged="onSelStudentStatusSearchFromChanged"
                            :selectedVal="selStudentStatusSearchFrom"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail-white">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <label
                            >{{ $t("messages.general.to") }}
                            {{ $t("messages.general.studentStatus") }}</label
                          >
                        </div>
                        <div class="col no-margin-padding">
                          <StudentStatus
                            :onChanged="onSelStudentStatusSearchToChanged"
                            :selectedVal="selStudentStatusSearchTo"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-row flex-column justify-content-center align-items-center mt-5"
                  >
                    <div class="form-group">
                      <div class="form-inline">
                        <button
                          class="btn btn-primary btn-lg"
                          type="button"
                          @click="handleSearchStudentCode()"
                        >
                          {{ $t("messages.general.search") }}</button
                        >&nbsp;&nbsp;&nbsp;
                        <button
                          class="btn btn-light btn-lg"
                          type="button"
                          @click="cleartSearchStudentCode()"
                        >
                          {{ $t("messages.general.clearScreen") }}</button
                        >&nbsp;&nbsp;&nbsp;
                      </div>
                    </div>
                  </div>
                </form>
                <v-card>
                  <b-table
                    bordered
                    hover
                    small
                    responsive
                    caption-top
                    class="table table-striped text-center"
                    :sort-by.sync="bTableSearch.sortBy"
                    :sort-desc.sync="bTableSearch.sortDesc"
                    :items="bTableSearch.items"
                    :fields="bTableSearch.fields"
                    :per-page="perPage"
                    :current-page="currentPageSearch"
                  >
                    <template slot="table-caption">
                      <div class="float-left">
                        <b class="mr-2">{{
                          $t("messages.general.table.paginationinfo")
                        }}</b>
                        <b-form-select
                          v-model="perPage"
                          :options="perPageOptions"
                          size="sm"
                          style="width:70px"
                        />
                      </div>
                      <b-pagination
                        class="float-right"
                        size="sm"
                        :total-rows="bTableSearch.items.length"
                        v-model="currentPageSearch"
                        :per-page="perPage"
                      />
                      <div
                        v-if="bTableSearch.items.length > 0"
                        class="float-right data-table-page-info"
                      >
                        {{
                          Number(
                            currentPageSearch > 1
                              ? (currentPageSearch - 1) * perPage + 1
                              : currentPageSearch
                          ).toLocaleString()
                        }}
                        -
                        {{
                          Number(
                            currentPageSearch * perPage >
                              bTableSearch.items.length
                              ? bTableSearch.items.length
                              : currentPageSearch * perPage
                          ).toLocaleString()
                        }}
                        {{ $t("messages.general.fromRecords") }}
                        {{ Number(bTableSearch.items.length).toLocaleString() }}
                      </div>
                      <div
                        v-if="bTableSearch.items.length <= 0"
                        class="float-right data-table-page-info"
                      >
                        0 - 0
                        {{ $t("messages.general.fromRecords") }}
                        {{ Number(bTableSearch.items.length).toLocaleString() }}
                      </div>
                    </template>

                    <template v-slot:cell(STUDENTID)="data">
                      <a
                        @click="handleSelectStudent(data.item, data.index)"
                        style="text-decoration: underline;"
                      >
                        {{ data.item.STUDENTID }}
                      </a>
                    </template>

                    <template slot="table-caption">
                      <div
                        style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                      >
                        <div class="float-left">
                          <b class="mr-2">{{
                            $t("messages.general.table.paginationinfo")
                          }}</b>
                          <b-form-select
                            v-model="perPage"
                            :options="perPageOptions"
                            size="sm"
                            style="width:70px"
                          />
                        </div>
                        <b-pagination
                          class="float-right"
                          size="sm"
                          :total-rows="bTableSearch.items.length"
                          v-model="currentPageSearch"
                          :per-page="perPage"
                          style="padding-top: 10px"
                        />
                        <div
                          v-if="bTableSearch.items.length > 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          {{
                            Number(
                              currentPageSearch > 1
                                ? (currentPageSearch - 1) * perPage + 1
                                : currentPageSearch
                            ).toLocaleString()
                          }}
                          -
                          {{
                            Number(
                              currentPageSearch * perPage >
                                bTableSearch.items.length
                                ? bTableSearch.items.length
                                : currentPageSearch * perPage
                            ).toLocaleString()
                          }}
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableSearch.items.length).toLocaleString()
                          }}
                        </div>
                        <div
                          v-if="bTableSearch.items.length <= 0"
                          class="float-right data-table-page-info"
                          style="padding-top: 14px"
                        >
                          0 - 0
                          {{ $t("messages.general.fromRecords") }}
                          {{
                            Number(bTableSearch.items.length).toLocaleString()
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogStudentInfo"
            hide-overlay
            scrollable
            max-width="80%"
          >
            <v-card tile>
              <v-toolbar flat dense>
                <v-icon>mdi-file</v-icon>
                <v-toolbar-title>{{
                  $t("messages.general.showInfo")
                }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-toolbar-items>
                  <v-btn icon @click="dialogStudentInfo = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-card-text dark>
                <div class="information-block">
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.identity") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.fullname") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.educationLvl") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.educationYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.faculty") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.department") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>
                            {{ $t("messages.general.educationCourse") }}
                          </div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.academicYear") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        >
                          <div>{{ $t("messages.general.semester") }}</div>
                        </div>
                        <div class="col no-margin-padding">
                          <!-- <div>{{ selectedStudent.STUDENTID }}</div> -->
                        </div>
                      </div>
                    </div>
                    <div class="col no-padding-bottom">
                      <div class="information-detail">
                        <div
                          class="col no-margin-padding"
                          style="flex: 0 0 10em;"
                        ></div>
                        <div class="col no-margin-padding"></div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row">
                  <div class="col no-padding-bottom">
                    <div class="information-detail-white">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      ></div>
                      <div class="col no-margin-padding">
                        <button
                          class="btn btn-primary btn-lg"
                          @click="dialogStudentInfo = false"
                        >
                          {{ $t("messages.general.close") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col no-padding-bottom">
                    <div class="information-detail">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 10em;"
                      ></div>
                      <div class="col no-margin-padding"></div>
                    </div>
                  </div>
                </div> -->
                  <br />
                  <div class="table-responsive">
                    <table class="table table-striped" id="table-epp1">
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ $t("messages.general.seqOrder") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.classId") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.className") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.section") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.reason") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.periodRequest") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.confirm") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.resultApprove") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in selectedStudentData"
                          :key="index"
                        >
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-center">{{ item.COURSECODE }}</td>
                          <td v-html="item.COURSENAME">
                            {{ item.COURSENAME }}
                          </td>
                          <td class="text-center">
                            {{ item.SECTION }}
                          </td>
                          <td class="text-center">{{ item }}</td>
                          <td class="text-center">{{ item }}</td>
                          <td class="text-center">{{ item }}</td>
                          <td class="text-center">{{ item }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import StudentStatus from "@/components/Dropdown/StudentStatus.vue";
import EnrollProvider from "@/services/enroll_provider";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "chkStudentInfo",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    StudentStatus
  },
  data() {
    return {
      dialogSearchProgram: false,
      dialogSearch: false,
      dialogStudentInfo: false,
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      selDepartment: 0,
      selStudentStatusFrom: 0,
      selStudentStatusTo: 0,
      selFacultySearch: 0,
      selDepartmentSearch: 0,
      selLvlSearch: 0,
      selStudentStatusSearchFrom: 0,
      selStudentStatusSearchTo: 0,
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            tdClass: "col-50"
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            tdClass: "col-50",
            sortable: true
          },
          {
            key: "STUDENTID",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 110px",
            sortable: true
          },
          {
            key: "FULLNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            thStyle: "width: 250px",
            tdClass: "text-left text-nowarp col-250",
            sortable: true
          },
          {
            key: "DEPARTMENTGROUPNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-250",
            sortable: true
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 100px",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "STUDENTSTATUSDES",
            label: this.$t("messages.general.statusStudent"),
            thClass: "align-middle text-warp",
            thStyle: "width: 100px",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "GRADE",
            label: this.$t("messages.general.gpa"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true
          },
          {
            key: "CHECKPREREG",
            label: this.$t("messages.general.informStatus"),
            thClass: "align-middle",
            thStyle: "width: 65px",
            sortable: true
          },
          {
            key: "CHECKPREREG_CONFIRM",
            label: this.$t("messages.general.confirmStatus"),
            thClass: "align-middle",
            thStyle: "width: 65px",
            sortable: true
          }
        ]
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 }
      ],
      perPage: 100,
      currentPage: 1,
      currentPageSearch: 1,
      currentPageProgram: 1,
      dlgSearchStudentId: "",
      dlgSearchStudentName: "",
      bTableSearch: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "STUDENTID",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "FULLNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true
          },
          {
            key: "DEPARTMENTGROUPNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true
          }
        ]
      },
      bTableProgram: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "PROGRAMCODE",
            label: this.$t("messages.general.programcode"),
            thClass: "align-middle",
            sortable: true
          },
          {
            key: "PROGRAMNAME",
            label: this.$t("messages.general.programName"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true
          },
          {
            key: "DEPARTMENTNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true
          },
          {
            key: "PROGRAMYEAR",
            label: this.$t("messages.general.yearRef"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true
          }
        ]
      },
      searchSelIdx: 0,
      selectedStudentIdx: 0,
      selectedStudent: false,
      selectedStudentData: [],
      programs: [],
      infoFormStatus: 2,
      regStatus: 0,
      dlgProgramCode: "",
      dlgProgramName: "",
      selFacultyProgram: 0,
      selDepartmentProgram: 0,
      selLvlProgram: 0,
      selYearProgram: 0,
      txtProgramCode: "",
      txtProgramName: "",
      programSelIdx: 0,
      selectedYear: 0,
      selectedYearOpts: [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 }
      ],
      studentCodeMode: "",
      txtStudentCodeFrom: "",
      txtStudentNameFrom: "",
      txtStudentCodeTo: "",
      txtStudentNameTo: "",
      selItem: 0
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    }
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selLvlSearch = 3;
    this.selLvlProgram = 3;
    this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
    this.selItem = 0;
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", [
      "togglePreLoader",
      "tokenHealthChk",
      "setStudentInfo"
    ]),
    async openDialogSearch(mode) {
      this.togglePreLoader(true);
      if (this.txtStudentCodeFrom != "" && mode == "from") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeFrom
        );
        if (result) {
          this.txtStudentCodeFrom = result.code;
          this.txtStudentNameFrom = result.name;
        } else {
          this.txtStudentNameFrom = "";
        }
      } else if (this.txtStudentCodeTo != "" && mode == "to") {
        const result = await this.handleSearchStudentKey(this.txtStudentCodeTo);
        if (result) {
          this.txtStudentCodeTo = result.code;
          this.txtStudentNameTo = result.name;
        } else {
          this.txtStudentNameTo = "";
        }
      } else {
        this.cleartSearchStudentCode();
        this.dialogSearch = true;
        this.studentCodeMode = mode;
      }
      this.togglePreLoader(false);
    },
    async openDialogStudentInfo(data, idx) {
      this.togglePreLoader(true);
      this.dialogStudentInfo = true;
      this.selectedStudentIdx = idx;
      this.selectedStudent = data;
      this.togglePreLoader(false);
    },
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelDepartmentChanged(event) {
      this.selDepartment = parseInt(event.target.value);
    },
    onSelStudentStatusFromChanged(event) {
      this.selStudentStatusFrom = parseInt(event.target.value);
    },
    onSelStudentStatusToChanged(event) {
      this.selStudentStatusTo = parseInt(event.target.value);
    },
    onSelFacultySearchChanged(event) {
      this.selFacultySearch = parseInt(event.target.value);
    },
    onSelDepartmentSearchChanged(event) {
      this.selDepartmentSearch = parseInt(event.target.value);
    },
    onSelLvlSearchChanged(event) {
      this.selLvlSearch = parseInt(event.target.value);
    },
    onSelStudentStatusSearchFromChanged(event) {
      this.selStudentStatusSearchFrom = parseInt(event.target.value);
    },
    onSelStudentStatusSearchToChanged(event) {
      this.selStudentStatusSearchTo = parseInt(event.target.value);
    },
    onSelFacultyProgramChanged(event) {
      this.selFacultyProgram = parseInt(event.target.value);
    },
    onSelDepartmentProgramChanged(event) {
      this.selDepartmentProgram = parseInt(event.target.value);
    },
    onSelLvlProgramChanged(event) {
      this.selLvlProgram = parseInt(event.target.value);
    },
    onSelYearProgramChanged(event) {
      this.selYearProgram = parseInt(event.target.value);
    },
    handleSelectStudent(data, idx) {
      this.searchSelIdx = idx;
      if (this.studentCodeMode == "from") {
        this.txtStudentCodeFrom = data.STUDENTCODE;
        this.txtStudentNameFrom = data.FULLNAME;
      } else {
        this.txtStudentCodeTo = data.STUDENTCODE;
        this.txtStudentNameTo = data.FULLNAME;
      }
      this.dialogSearch = false;
    },
    handleSelectProgram(data, idx) {
      this.programSelIdx = idx;
      this.txtProgramCode = data.PROGRAMCODE;
      this.txtProgramName = data.PROGRAMNAME;
      this.dialogSearchProgram = false;
      this.cleartSearchProgram();
    },
    clearSelectProgram() {
      this.txtProgramCode = "";
      this.txtProgramName = "";
    },
    async getPrograms() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          lang: this.currentLang,
          programyear: this.selYearProgram,
          levelid: this.selLvl
        }
      };
      if (this.selFacultyProgram != 0) {
        params.request.facultyid = this.selFacultyProgram;
      }
      if (this.selDepartmentProgram != 0) {
        params.request.departmentid = this.selDepartmentProgram;
      }
      if (this.dlgProgramCode != "") {
        params.request.programcode = this.dlgProgramCode;
      }
      if (this.dlgProgramName != "") {
        params.request.programname = this.dlgProgramName;
      }
      const result = await enrollProvider.getSearchProgram(params);
      this.bTableProgram.items = [];
      if (result.length > 0) {
        let idx = 0;
        result.map(d => {
          d.rowNumber = idx + 1;
          this.bTableProgram.items.push(d);
          idx++;
        });
      }
      this.togglePreLoader(false);
    },
    async handleSearchStudent() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          acadyear: this.selYear,
          semester: this.selSemester,
          levelid: this.selLvl,
          officerid: this.mfuUserId,
          regstatus: this.regStatus,
          preregstatus: this.infoFormStatus,
          lang: this.currentLang
        }
      };
      if (this.selFaculty != 0) {
        params.request.facultyid = this.selFaculty;
      }
      if (this.selDepartment != 0) {
        params.request.departmentid = this.selDepartment;
      }
      if (this.txtProgramCode != "") {
        params.request.programid = this.txtProgramCode;
      }
      if (this.selectedYear != 0) {
        params.request.studentyear = this.selectedYear;
      }
      if (this.studentcodefrom != 0) {
        params.request.studentcodefrom = this.txtStudentCodeFrom;
      }
      if (this.studentcodeto != 0) {
        params.request.studentcodeto = this.txtStudentCodeTo;
      }
      if (this.selStudentStatusFrom != 0) {
        params.request.studentstatusfrom = this.selStudentStatusFrom;
      }
      if (this.selStudentStatusTo != 0) {
        params.request.studentstatusto = this.selStudentStatusTo;
      }
      const result = await enrollProvider.searchStudent(params);
      this.bTable.items = [];
      if (result.length > 0) {
        let idx = 0;
        if (!result[idx].hasOwnProperty("ERR_DESC")) {
          result.map(d => {
            d.rowNumber = idx + 1;
            d.FULLNAME = `${d.PREFIXNAME} ${d.STUDENTNAME} ${d.STUDENTSURNAME}`;
            this.bTable.items.push(d);
            idx++;
          });
        }
      }
      this.togglePreLoader(false);
    },
    async handleSearchStudentCode() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang
        }
      };
      if (this.dlgSearchStudentId != 0) {
        params.request.studentcode = this.dlgSearchStudentId;
      }
      if (this.dlgSearchStudentName != "") {
        params.request.studentname = this.dlgSearchStudentName;
      }
      if (this.selFacultySearch != 0) {
        params.request.facultyid = this.selFacultySearch;
      }
      if (this.selDepartmentSearch != 0) {
        params.request.departmentid = this.selDepartmentSearch;
      }
      if (this.selStudentStatusSearchFrom != 0) {
        params.request.studentstatusfrom = this.selStudentStatusSearchFrom;
      }
      if (this.selStudentStatusSearchTo != 0) {
        params.request.studentstatusto = this.selStudentStatusSearchTo;
      }
      const result = await enrollProvider.searchStudentCode(params);
      this.bTableSearch.items = [];
      if (result.length > 0) {
        let idx = 0;
        if (!result[idx].hasOwnProperty("ERR_DESC")) {
          result.map(d => {
            d.rowNumber = idx + 1;
            d.FULLNAME = `${d.PREFIXNAME} ${d.STUDENTNAME} ${d.STUDENTSURNAME}`;
            this.bTableSearch.items.push(d);
            idx++;
          });
        }
      }
      this.togglePreLoader(false);
    },
    handleSearchProgram() {
      this.cleartSearchProgram();
      this.dialogSearchProgram = true;
    },
    cleartSearchProgram() {
      this.dlgProgramCode = "";
      this.dlgProgramName = "";
      this.selFacultyProgram = 0;
      this.selDepartmentProgram = 0;
      this.selLvlProgram = 3;
      this.selYearProgram = this.appInfo.data.ENROLL_ACADYEAR;
      this.bTableProgram.items = [];
    },
    cleartSearchStudentCode() {
      this.studentCodeMode = "";
      this.dlgSearchStudentId = "";
      this.dlgSearchStudentName = "";
      this.selFacultySearch = 0;
      this.selDepartmentSearch = 0;
      this.selLvlSearch = 3;
      this.selStudentStatusSearchFrom = 0;
      this.selStudentStatusSearchTo = 0;
      this.bTableSearch.items = [];
    },
    clearAll() {
      this.cleartSearchProgram();
      this.cleartSearchStudentCode();
      this.clearSelectProgram();
      this.clearStudentFrom();
      this.clearStudentTo();
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = 0;
      this.selLvl = 0;
      this.infoFormStatus = 2;
      this.regStatus = 0;
      this.selFaculty = 0;
      this.selDepartment = 0;
      this.selectedYear = 0;
      this.selStudentStatusFrom = 0;
      this.selStudentStatusTo = 0;
    },
    clearStudentFrom() {
      this.txtStudentCodeFrom = "";
      this.txtStudentNameFrom = "";
    },
    clearStudentTo() {
      this.txtStudentCodeTo = "";
      this.txtStudentNameTo = "";
    },
    async handleProgramSearch() {
      await this.getPrograms();
    },
    async handleSelect(data, idx) {
      this.selItem = idx;
      const menus = await masterDataProvider.getMenu({
        token: this.token,
        userId: data.STUDENTID,
        lang: this.currentLang
      });
      this.setStudentInfo({
        studentId: data.STUDENTID,
        data: data,
        menus: menus
      });

      // ขอตั้ง default ไว้ที่หน้าลงทะเบียนเรียน กรณีที่กดตรวจสอบข้อมูลนักศึกษา
      const redirectPage =
        menus.length > 0 && menus[0].ENROLLPERIOD == 1 ? "/register" : "/";
      this.$router.push(redirectPage);
    },
    async handleSearchStudentFromKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeFrom != "") {
        this.togglePreLoader(true);
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeFrom
        );
        if (result) {
          this.txtStudentCodeFrom = result.code;
          this.txtStudentNameFrom = result.name;
        } else {
          this.txtStudentNameFrom = "";
        }
        this.togglePreLoader(false);
      }
    },
    async handleSearchStudentToKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeTo != "") {
        this.togglePreLoader(true);
        const result = await this.handleSearchStudentKey(this.txtStudentCodeTo);
        if (result) {
          this.txtStudentCodeTo = result.code;
          this.txtStudentNameTo = result.name;
        } else {
          this.txtStudentNameTo = "";
        }
        this.togglePreLoader(false);
      }
    },
    async handleSearchStudentKey(code) {
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang
        }
      };
      params.request.studentcode = code;
      const result = await enrollProvider.searchStudentCode(params);
      if (result.length > 0 && result[0].ERR_DESC === undefined) {
        return {
          code: `${result[0].STUDENTCODE}`,
          name: `${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`
        };
      } else {
        return false;
      }
    }
  },
  watch: {
    async currentLang() {
      // สลับภาษาในหน้า ตรวจสอบข้อมูลนักศึกษา ระบบทำการค้นหาให้โดยยังไม่ได้กดปุ่มค้นหาครับ
      // await this.handleSearchStudent();
      this.selectedYearOpts = [
        { text: this.$t("messages.general.notSpecified"), value: 0 },
        { text: "1", value: 1 },
        { text: "2", value: 2 },
        { text: "3", value: 3 },
        { text: "4", value: 4 },
        { text: "5", value: 5 },
        { text: "6", value: 6 },
        { text: "7", value: 7 },
        { text: "8", value: 8 }
      ];
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          tdClass: "col-50"
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          tdClass: "col-50",
          sortable: true
        },
        {
          key: "STUDENTID",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 110px",
          sortable: true
        },
        {
          key: "FULLNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          thStyle: "width: 250px",
          tdClass: "text-left text-nowarp col-250",
          sortable: true
        },
        {
          key: "DEPARTMENTGROUPNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-250",
          sortable: true
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 100px",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "STUDENTSTATUSDES",
          label: this.$t("messages.general.statusStudent"),
          thClass: "align-middle text-warp",
          thStyle: "width: 100px",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "GRADE",
          label: this.$t("messages.general.gpa"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true
        },
        {
          key: "CHECKPREREG",
          label: this.$t("messages.general.informStatus"),
          thClass: "align-middle",
          thStyle: "width: 65px",
          sortable: true
        },
          {
            key: "CHECKPREREG_CONFIRM",
            label: this.$t("messages.general.confirmStatus"),
            thClass: "align-middle",
            thStyle: "width: 65px",
            sortable: true
          }
      ];
      this.bTableSearch.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          tdClass: "col-50",
          sortable: true
        },
        {
          key: "STUDENTID",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "FULLNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true
        },
        {
          key: "DEPARTMENTGROUPNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true
        }
      ];
      this.bTableProgram.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "PROGRAMCODE",
          label: this.$t("messages.general.programcode"),
          thClass: "align-middle",
          sortable: true
        },
        {
          key: "PROGRAMNAME",
          label: this.$t("messages.general.programName"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true
        },
        {
          key: "DEPARTMENTNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true
        },
        {
          key: "PROGRAMYEAR",
          label: this.$t("messages.general.yearRef"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true
        }
      ];
    }
  }
};
</script>
